import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { API } from '@/config/api';

export default function SharesDebugPage({ token, user }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchShares = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('Fetching with token:', token?.substring(0, 20));
      console.log('User:', user);
      
      const response = await axios.get(`${API}/share/direct/received`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Response:', response);
      setData(response.data);
    } catch (err) {
      console.error('Error:', err);
      setError(err.message + ' - ' + (err.response?.status || 'No status'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchShares();
    }
  }, [token]);

  return (
    <div className="p-8">
      <Card>
        <CardHeader>
          <CardTitle>Shares Debug Page</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <strong>User:</strong> {user?.name || 'Not logged in'}
            </div>
            <div>
              <strong>User ID:</strong> {user?.user_id || 'N/A'}
            </div>
            <div>
              <strong>Token Present:</strong> {token ? 'Yes' : 'No'}
            </div>
            
            <Button onClick={fetchShares} disabled={loading}>
              {loading ? 'Loading...' : 'Fetch Shares'}
            </Button>

            {error && (
              <div className="bg-red-100 p-4 rounded text-red-800">
                <strong>Error:</strong> {error}
              </div>
            )}

            {data && (
              <div className="bg-green-100 p-4 rounded">
                <strong>Success! Received {data.shares?.length || 0} shares</strong>
                <pre className="mt-2 text-xs overflow-auto max-h-96">
                  {JSON.stringify(data, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
